import { createFileRoute } from "@tanstack/react-router";
import { PendingSurface } from "@/components/feedback/pending-surface";
import { requirePerm } from "@/lib/auth/guards";
export const Route = createFileRoute("/_authenticated/patients")({
  beforeLoad: requirePerm("VIEW_PATIENT"),
  component: () => <PendingSurface titleKey="nav.patients" />,
});
